import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import FormComponent from '../FormComponent';
import InputField from '../InputField';
import _ from "lodash";

const SELECTOR_INPUT = 'input';
const CLICK_EVENT = 'click';

const HIDDEN_CLASS = 'u-hidden';

class SchoolAddressSearch extends FormComponent {
	constructor(element, config) {
		super(element, config);
	}
	markup(value, rowData, titleMarkup) {
        this.Urn = rowData?.urn;
        return `
            <div class="lta-school-address-search">
				<div class="lta-school-address-search-title u-hidden">${titleMarkup}</div>
                <div class="lta-school-address-search--address-form u-mb-2">
                    <div class="lta-school-address-search--school-name u-mb-3"></div>
                    <div class="lta-school-address-search--address-line1 u-mb-3"></div>
                    <div class="lta-school-address-search--address-line2 u-mb-3"></div>
                    <div class="lta-school-address-search--town u-mb-3"></div>
                    <div class="lta-school-address-search--postcode u-mb-3"></div>
                    ${this.Urn ? '<div class="lta-school-address-search--urn u-mb-3"></div>' : ''}
                </div>
            </div>
        `;
	}
	afterRender() { 
		this.schoolAddressSearchElement = SelectorEngine.findOne('.lta-school-address-search', this.containerEl);
        this.schoolAddressSearchForm = SelectorEngine.findOne('.lta-school-address-search--address-form', this.schoolAddressSearchElement);
        this.schoolAddressSchoolName = SelectorEngine.findOne('.lta-school-address-search--school-name', this.schoolAddressSearchForm);
        this.schoolAddressAddressLine1 = SelectorEngine.findOne('.lta-school-address-search--address-line1', this.schoolAddressSearchForm);
        this.schoolAddressAddressLine2 = SelectorEngine.findOne('.lta-school-address-search--address-line2', this.schoolAddressSearchForm);
        this.schoolAddressTown = SelectorEngine.findOne('.lta-school-address-search--town', this.schoolAddressSearchForm);
        this.schoolAddressPostcode = SelectorEngine.findOne('.lta-school-address-search--postcode', this.schoolAddressSearchForm);
        this.schoolAddressUrn = SelectorEngine.findOne('.lta-school-address-search--urn', this.schoolAddressSearchForm);
        this.addressObjects = [];
        this.addressObjects = [
            {
                inputElementData: this.schoolAddressSchoolName,
                elementDataKey: 'schoolName'
            },
            {
                inputElementData: this.schoolAddressAddressLine1,
                elementDataKey: 'addressLine1'
            },
            {
                inputElementData: this.schoolAddressAddressLine2,
                elementDataKey: 'addressLine2'
            },
            {
                inputElementData: this.schoolAddressTown,
                elementDataKey: 'county'
            },
            {
                inputElementData: this.schoolAddressPostcode,
                elementDataKey: 'postcode'
            }
        ];
        if (this.Urn) {
            this.schoolAddressUrn = SelectorEngine.findOne('.lta-school-address-search--urn',this.schoolAddressSearchForm);
            this.addressObjects.push({
                inputElementData: this.schoolAddressUrn,
                elementDataKey: 'urn'
            });
        }
        this.initInputObject();
	}
    initInputObject() {
        let schoolSearchAddressObject = {};
        for (const addressObject of  this.addressObjects) {
            const inputFieldObject = new InputField(addressObject.inputElementData, {
                data: this.data[addressObject.elementDataKey]
            });
            addressObject.inputElement = inputFieldObject;
            inputFieldObject.onChange((dataObject) => {
                addressObject.value = dataObject.value;
                if(addressObject?.value?.length > 2 ) {
                    const valueObject = {
                        address: {
                            street: null,
                            city: null,
                            state: null
                        }
                    };
                    valueObject[addressObject.elementDataKey] = addressObject?.value;
                    schoolSearchAddressObject = {
                        ...schoolSearchAddressObject,
                        ...valueObject
                    }
                }

                const allFieldsEntered = this.addressObjects.every(
                    (obj) => schoolSearchAddressObject[obj.elementDataKey]
                );

                if (allFieldsEntered) {
                    const finalObject = this.prepareAddressObject(
                        schoolSearchAddressObject
                    );

                    this.value = {
                        ...this.value,
                        ...finalObject
                    };
                }
            });
        }
    }
    prepareAddressObject(schoolObject) {
        const modifyObject = {
            "id": '',
            "schoolName": schoolObject.schoolName,
            "county": '',
            "postcode": schoolObject.postcode,
            "address": {
               "street": schoolObject.addressLine1,
               "city":schoolObject.addressLine2,
               "state":schoolObject.county
            },
        };

        if (schoolObject.urn) {
            modifyObject.urn = schoolObject.urn;
        }
        return modifyObject;
    }
    validate() {
        return this.addressObjects.every(
            (inputElementObject) =>
                inputElementObject.inputElement.validate()
        );
    }
}
export default SchoolAddressSearch;
